const path = (root, sublink) => {
    return `${root}${sublink}`;
};
  
const ROOTS_AUTH = "/auth";

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
};

export const PATH_PAGE = {
  root: "/",
  home: "/home",
  intro: "/intro",
  amenities: "/amenities",
  contact: "/contact",
  gallery: "/gallery",
  nearme: "/nearme",
  building: "/building",
  buildingApto: "/buildingApto",
  page404: "/404",
};